import React from 'react';

interface QRCodeDisplayProps {
  qrCodeDataUrl?: string;
  size?: number;
  title?: string;
  className?: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({
  qrCodeDataUrl,
  size = 200,
  title = 'QR Code',
  className = ''
}) => {
  if (!qrCodeDataUrl) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 rounded-lg ${className}`} style={{ width: size, height: size }}>
        <div className="text-center">
          <div className="w-16 h-16 bg-gray-300 rounded-lg mx-auto mb-2"></div>
          <p className="text-xs text-gray-500">QR Code</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {title && <p className="text-sm font-medium text-gray-700 mb-2">{title}</p>}
      <img 
        src={qrCodeDataUrl} 
        alt="QR Code" 
        style={{ width: size, height: size }}
        className="border border-gray-300 rounded-lg shadow-sm"
      />
    </div>
  );
};

export default QRCodeDisplay;
